import store from '../../store';

export default {
	/**
	 * Event to trigger before route is processed.
	 * @param {object} context The context to be accessed. Has `to`, `from`, and `next` keys.
	 * @returns {mixed} The next context must be returned.
	 */
	before: ({ next }) => {
		next();
	},

	/**
	 * Event to trigger after route is processed.
	 * @param {object} context The context to be accessed. Has `to` and `from` keys.
	 * @returns {void}
	 */
	after: ({ to }) => {
		store.commit('ui/setCollapsed', to.meta.collapse === true);
	}
};
